<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo class="d-none d-lg-block" />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('maintenance.header') }}
        </h2>
        <p
          class="mb-2"
          v-html="$t('maintenance.description') "
        />

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="reload"
        >
          {{ $t('maintenance.btn') }}
        </b-button>

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
        />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
import logo from '@/views/theme1/components/logo.vue'
import maintenance from '@/views/logics/error/maintenance'

export default {
  components: {
    logo,
  },
  mixins: [maintenance],
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
